import React from 'react';

export const getContainerWidth = (gap = 0) => {
  const [container, setContainer] = React.useState<HTMLElement>(null);

  const containerWidth = container
    ? container.clientWidth -
      parseFloat(getComputedStyle(container).padding) * 2 -
      gap * 2
    : 0;

  return {
    containerWidth,
    setContainer
  };
};
